import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialOutPopup } from './MaterialOutTable';
import { decryptAES } from '../../../utils/Encryption';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import moment from 'moment';
import { permission } from "../../../utils/enums/ValidationMessage.js";

export default class MaterialOut extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            partyAccountList: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialObject: {
                iDMaterialOut: 0,
                updateStatus: '',
                challanNo: '',
                challanDate: '',
                iDVendor: 0,
                supplierList: [],
                address: "",
                referenceNo: '',
                otherReferences: '',
                orderNo: '',
                orderDate: '',
                documentNo: '',
                documentDate: '',
                dispatchThrough: '',
                remarks: ''
            },
            itemObject: {
                iDMaterialOut: 0,
                itemDetails: "",
                quantity: "",
                rate: "",
                amount: "",
                remarks: "",
                index: null
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForMaterial: {
                challanDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "challan date"
                        ),
                    },
                ],
                iDVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                itemDetails: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item details"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Out",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialOut"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Out",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Material Out");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.04,
            "challanNo": window.innerWidth * 0.04,
            "challandate": window.innerWidth * 0.06,
            "vendor": window.innerWidth * 0.23,
            "referenceNo": window.innerWidth * 0.06,
            "orderNo": window.innerWidth * 0.04,
            "orderDate": window.innerWidth * 0.06,
            "dispatchThrough": window.innerWidth * 0.06,
            "inwardStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "item": window.innerWidth * 0.4,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "amount": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                }
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.otherFormsServices.getInvoiceCountForMaterialOut(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let materialObject = this.state.materialObject
                materialObject.challanNo = formatted
                this.setState({ materialObject: materialObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.resetInvoiceItems()
                        this.setState({ itemRowData: [] })
                    })
                })
            }
        });
    };

    handleCellClick = (event) => {
        let data = this.state.itemObject;
        data.iDMaterialOut = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ itemObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Material Out");
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getOtherFormsMaterialOutByID(event.data.idMaterialOut);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForInvoice = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRulesForMaterial,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForInvoiceItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForMaterial = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        if (name === 'quantity' || name === 'rate') {
            details.amount = Number((Number(details.quantity) * Number(details.rate)).toFixed(2))
            details.quantity = Number(details.quantity)
            details.rate = Number(details.rate)
        }
        this.setState({ itemObject: details });
    }

    resetDetailsFields = () => {
        let details = this.state.materialObject
        details.iDMaterialOut = 0
        details.challanDate = ''
        details.referenceNo = ''
        details.otherReferences = ''
        details.iDVendor = ''
        details.orderNo = ''
        details.orderDate = ''
        details.documentNo = ''
        details.documentDate = ''
        details.dispatchThrough = ''
        details.address = ''
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            invoiceObject: details
        });
    }

    insertItem = (key) => {
        const isValidAllFields = this.isValidAllFieldsForInvoiceItem();
        if (isValidAllFields) {
            let data = [...this.state.itemRowData];
            let itemObject = this.state.itemObject;
            let itemRowData = {};
            itemRowData.itemDetails = itemObject.itemDetails;
            itemRowData.quantity = itemObject.quantity;
            itemRowData.rate = itemObject.rate;
            itemRowData.amount = itemObject.amount;
            itemRowData.remarks = itemObject.remarks;

            if (itemObject.index !== null && itemObject.index >= 0) {
                data[itemObject.index] = itemRowData;
            } else {
                data.push(itemRowData);
            }
            this.setState({ itemRowData: data }, () => {
                let data = this.state.itemRowData;
                let itemObject = this.state.itemObject

                if (data.length > 0) {
                    this.setState({
                        itemObject: itemObject,
                    }, () => {
                        this.resetInvoiceItems();
                    });
                }
            });
        }
    }

    resetInvoiceItems = () => {
        let itemObject = this.state.itemObject;
        itemObject.itemDetails = "";
        itemObject.quantity = "";
        itemObject.rate = "";
        itemObject.amount = "";
        itemObject.remarks = "";
        itemObject.index = null;
        this.setState({ itemObject: itemObject })
    }

    handleCellClickItemList = (event) => {
        let details = event.data
        let itemObject = this.state.itemObject
        itemObject = details
        itemObject.index = event.rowIndex
        this.setState({ itemObject: itemObject })

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };

    deleteItem = () => {
        let details = this.state.itemObject
        let data = [...this.state.itemRowData];
        data.splice(details.index, 1);
        this.setState({ itemRowData: data }, () => {
            this.resetInvoiceItems();
        })
    }

    setFilterParameters = (event, name) => {
        let details = this.state.materialObject;
        details[name] = event.value;
        details.address = event.partyAddress
        this.setState({ materialObject: details });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFieldsForInvoice();
        if (isValidAllFields) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Error("Please add material out details.");
            } else {
                let details = this.state.materialObject;
                let details2 = this.state.itemRowData;
                let materialOutItemList = [];
                details2.map((x) => {
                    let request = {
                        itemDetails: x.itemDetails,
                        quantity: x.quantity,
                        rate: x.rate,
                        amount: x.amount,
                        remarks: x.remarks,
                    }
                    materialOutItemList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        iDMaterialOut: details.iDMaterialOut,
                        updateStatus: details.updateStatus,
                        challanNo: details.challanNo,
                        challanDate: (details.challanDate && details.challanDate !== 'Invalid date') ? details.challanDate : null,
                        iDVendor: details.iDVendor,
                        referenceNo: details.referenceNo,
                        otherReferences: details.otherReferences,
                        orderNo: details.orderNo,
                        orderDate: (details.orderDate && details.orderDate !== 'Invalid date') ? details.orderDate : null,
                        documentNo: details.documentNo,
                        documentDate: (details.documentDate && details.documentDate !== 'Invalid date') ? details.documentDate : null,
                        dispatchThrough: details.dispatchThrough,
                        remarks: details.remarks,
                        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updatedDate ? details.updatedDate : new Date().toISOString(),
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        idCompany: this.state.idCompany,
                        materialOutItemList: materialOutItemList,
                    }
                    this.otherFormsServices.submitMaterialOutInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.materialObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    this.resetDetailsFields();
                                    this.setState(
                                        { isModalOpen: false },
                                        () => {
                                            this.procSelectAllRecordsSP();
                                        }
                                    );
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        });
                }
            }
        }
    }

    getOtherFormsMaterialOutByID = (id) => {
        this.otherFormsServices.getOtherFormsMaterialOutByID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    const party = this.state.partyAccountList?.find(x => x.value === res.idVendor);
                    let data = this.state.materialObject;
                    data.iDMaterialOut = res.idMaterialOut;
                    data.challanNo = res.challanNo;
                    data.updateStatus = 1;
                    data.challanDate = res.challanDate ? moment(res.challanDate).format('YYYY-MM-DD') : "";
                    data.orderDate = res.orderDate ? moment(res.orderDate).format('YYYY-MM-DD') : "";
                    data.documentDate = res.documentDate ? moment(res.documentDate).format('YYYY-MM-DD') : "";
                    data.referenceNo = res.referenceNo;
                    data.otherReferences = res.otherReferences;
                    data.iDVendor = res.idVendor;
                    data.address = party ? party.partyAddress : '';
                    data.orderNo = res.orderNo;
                    data.documentNo = res.documentNo;
                    data.dispatchThrough = res.dispatchThrough;
                    data.e_Date = res.e_Date ? res.e_Date : null;
                    this.setState({
                        materialObject: data,
                        isModalOpen: true
                    });
                    this.otherFormsServices.getOtherFormsMaterialOutItemsByID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            let itemObject = this.state.itemObject;
                            let materialOutItemList = [];
                            if (value.length > 0) {
                                value.map((x) => {
                                    let request = {
                                        itemDetails: x.item,
                                        quantity: x.quantity,
                                        rate: x.rate,
                                        amount: x.amount,
                                        remarks: x.ItemRemarks,
                                    }
                                    materialOutItemList.push(request);
                                });
                                if (materialOutItemList.length > 0) {
                                    this.setState({
                                        itemRowData: materialOutItemList,
                                    }, () => {
                                        this.resetInvoiceItems();
                                    });
                                }
                                this.setState({ itemObject: itemObject });
                            }
                        }
                    });

                }
            }
        });
    }

    render() {
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialOutPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            itemObject={this.state.itemObject}
                            handleChangeForMaterial={this.handleChangeForMaterial.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}

                            partyAccountList={this.state.partyAccountList}
                            insertItem={this.insertItem.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            submit={this.submit.bind(this)}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 350px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material Out</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
